// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input.form-control {
  outline: none !important;
  box-shadow: none !important;
  border: 1px solid #ccc !important;
}
input.form-control:focus {
  border-color: blue !important;
}

button.btn,
input {
  width: 100%;
  max-width: 350px;
}

.img {
  width: 100%;
  max-width: 280px;
  min-width: 150px;
  margin-bottom: 40px;
}

p,
.back-btn {
  color: #999;
}

.forgot-pass {
  height: 100vh;
  padding-top: 80px;
}
.forgot-pass .forgot-pass-form {
  width: 100%;
  max-width: 350px;
}
.forgot-pass .desc {
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
}

.check img {
  width: 125px;
  height: 125px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZvcmdvdC1wYXNzd29yZC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQTtFQUNJLHdCQUFBO0VBQ0EsMkJBQUE7RUFDQSxpQ0FBQTtBQURKO0FBR0k7RUFDSSw2QkFBQTtBQURSOztBQUtBOztFQUVJLFdBQUE7RUFDQSxnQkFmZTtBQWFuQjs7QUFLQTtFQUNJLFdBQUE7RUFDQSxnQkFBQTtFQUNBLGdCQUFBO0VBQ0EsbUJBQUE7QUFGSjs7QUFLQTs7RUFFSSxXQUFBO0FBRko7O0FBS0E7RUFDSSxhQUFBO0VBQ0EsaUJBQUE7QUFGSjtBQUtJO0VBQ0ksV0FBQTtFQUNBLGdCQXJDVztBQWtDbkI7QUFPSTtFQUNJLGdCQUFBO0VBQ0EsaUJBQUE7RUFDQSxrQkFBQTtBQUxSOztBQVVJO0VBQ0UsWUFBQTtFQUNBLGFBQUE7QUFQTiIsImZpbGUiOiJmb3Jnb3QtcGFzc3dvcmQuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIkZm9ybV9pbnB1dF93aWR0aDogMzUwcHg7XG5cbmlucHV0LmZvcm0tY29udHJvbCB7XG4gICAgb3V0bGluZTogbm9uZSAhaW1wb3J0YW50O1xuICAgIGJveC1zaGFkb3c6IG5vbmUgIWltcG9ydGFudDtcbiAgICBib3JkZXI6IDFweCBzb2xpZCAjY2NjICFpbXBvcnRhbnQ7XG5cbiAgICAmOmZvY3VzIHtcbiAgICAgICAgYm9yZGVyLWNvbG9yOiBibHVlICFpbXBvcnRhbnQ7XG4gICAgfVxufVxuXG5idXR0b24uYnRuLFxuaW5wdXQge1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIG1heC13aWR0aDogJGZvcm1faW5wdXRfd2lkdGg7XG59XG5cbi5pbWcge1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIG1heC13aWR0aDogMjgwcHg7XG4gICAgbWluLXdpZHRoOiAxNTBweDtcbiAgICBtYXJnaW4tYm90dG9tOiA0MHB4O1xufVxuXG5wLFxuLmJhY2stYnRuIHtcbiAgICBjb2xvcjogIzk5OTtcbn1cblxuLmZvcmdvdC1wYXNzIHtcbiAgICBoZWlnaHQ6IDEwMHZoO1xuICAgIHBhZGRpbmctdG9wOiA4MHB4O1xuICAgIC8vICAgYmFja2dyb3VuZC1jb2xvcjogI2VlZmNmZjtcblxuICAgIC5mb3Jnb3QtcGFzcy1mb3JtIHtcbiAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICAgIG1heC13aWR0aDogJGZvcm1faW5wdXRfd2lkdGg7XG5cbiAgICB9XG5cbiAgICAuZGVzYyB7XG4gICAgICAgIG1heC13aWR0aDogMzAwcHg7XG4gICAgICAgIG1hcmdpbi1sZWZ0OiBhdXRvO1xuICAgICAgICBtYXJnaW4tcmlnaHQ6IGF1dG87XG4gICAgfVxufVxuXG4uY2hlY2sge1xuICAgIGltZyB7XG4gICAgICB3aWR0aDogMTI1cHg7XG4gICAgICBoZWlnaHQ6IDEyNXB4O1xuICB9XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./libs/auth/src/lib/components/forgot-password/forgot-password.component.scss"],"names":[],"mappings":"AAEA;EACI,wBAAA;EACA,2BAAA;EACA,iCAAA;AADJ;AAGI;EACI,6BAAA;AADR;;AAKA;;EAEI,WAAA;EACA,gBAfe;AAanB;;AAKA;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAFJ;;AAKA;;EAEI,WAAA;AAFJ;;AAKA;EACI,aAAA;EACA,iBAAA;AAFJ;AAKI;EACI,WAAA;EACA,gBArCW;AAkCnB;AAOI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;AALR;;AAUI;EACE,YAAA;EACA,aAAA;AAPN;AACA,ouDAAouD","sourcesContent":["$form_input_width: 350px;\n\ninput.form-control {\n    outline: none !important;\n    box-shadow: none !important;\n    border: 1px solid #ccc !important;\n\n    &:focus {\n        border-color: blue !important;\n    }\n}\n\nbutton.btn,\ninput {\n    width: 100%;\n    max-width: $form_input_width;\n}\n\n.img {\n    width: 100%;\n    max-width: 280px;\n    min-width: 150px;\n    margin-bottom: 40px;\n}\n\np,\n.back-btn {\n    color: #999;\n}\n\n.forgot-pass {\n    height: 100vh;\n    padding-top: 80px;\n    //   background-color: #eefcff;\n\n    .forgot-pass-form {\n        width: 100%;\n        max-width: $form_input_width;\n\n    }\n\n    .desc {\n        max-width: 300px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n}\n\n.check {\n    img {\n      width: 125px;\n      height: 125px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
